export default "__VITE_ASSET__c51f38b5__"